<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            icon="fas fa-filter"
            type="success mx-2"
            title="فیلتر بیشتر"
            @click.native="toggleFilters"
          />
          <div style="text-align: center; margin-bottom: 20px;">
            <transition name="fade">
              <div v-show="showFilters">
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <div>
                        <plate-number-inputes
                          ref="plate"
                          v-model="filters.number_plate"
                          @input="(e) => driverSearch(e)"
                        />
                      </div>
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
          />
        </div>
      </bita-ibox>
    </div>
    <drivers-modal ref="driversModal" @load-data="loadData" />
  </div>
</template>
<script>
import Spinner from "../../../components/Spinner";
import PlateNumberInputes from "@/components/PlateNumberInputs.vue";
import DriversModal from "./components/DriversModal.vue";

export default {
  components: {
    PlateNumberInputes,
    Spinner,
    DriversModal,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/",
        },
        {
          title: "مدیریت ماشین آلات",
          link: "/management/drivers",
          active: true,
        },
      ],
      isLoadingGrid: false,
      isLoadingModal: false,
      showFilters: false,
      filters: {},
      pageSize: 0,
      currentPage: 0,
    };
  },
  computed: {
    gridColumns() {
      return [
        { title: "#", template: this.getTemplateID, width: "60px" },
        {
          field: "number_plate",
          title: "شماره پلاک خودرو",
          width: 100,
          template: (e) => (e.number_plate ? e.number_plate : "-"),
        },
        {
          field: "count_drivers",
          title: "تعداد راننده",
          width: 50,
          template: (e) => (e.count_drivers ? e.count_drivers : "-"),
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          width: 360,
        },
      ];
    },
  },

  methods: {
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `vehicles?page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },

    gridCommands() {
      let commands = [];
      commands.push({
        text: "users",
        click: this.driversModal,
        template:
          "<a role='button' class='k-button k-button-icontext k-grid-users' data-toggle='tooltip' data-placement='bottom' title='رانندگان'><span class='fas fa-users' style='color:rgb(20 169 217)'></span></a>",
      });
      return commands;
    },

    driversModal(e) {
      let driver = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.driversModal.setInitialData(driver);
      this.$toggleModal("#drivers-modal");
    },

    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filters = {};
        this.loadData();
        this.resetFilter();
      }
    },
    driverSearch: _.debounce(function() {
      this.loadData();
    }, 1000),
    resetFilter() {
      this.$refs.statusDropDown.emptyKendo();
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
